"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const hooks_1 = require("common/hooks");
const react_bootstrap_1 = require("react-bootstrap");
require("./searchDate.scss");
require("react-datepicker/dist/react-datepicker.css");
const searchDate_1 = require("./searchDate");
const timeZone = "Asia/Tokyo";
const MonthSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(react_bootstrap_1.InputGroup, { className: "searchDate" },
            react_1.default.createElement(searchDate_1.MonthPicker, Object.assign({ className: (0, classnames_1.default)("form-control", {
                    "has-error": fieldState.invalid,
                }), dateRange: value || (0, searchDate_1.relativeMonth)(null, 0) }, registerProps, { onChange: (v) => {
                    registerProps.onChange(v);
                } })))));
};
MonthSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MonthDisplayComponent", (value) => {
    const { formatDate } = (0, hooks_1.useFormatter)();
    return value ? formatDate(value) + "" : "";
});
exports.default = MonthSchemaComponent;
